export enum TabRoutesEnum {
  username = 'profile/security',
  password = 'profile/security/password',
  twoFA = 'profile/security/two-step-login',
  logs = 'profile/security/sessions',
  trustedDevices = 'profile/security/trusted-devices',
}
export const tabRouteKeys = {
  [TabRoutesEnum.username]: 0,
  [TabRoutesEnum.password]: 1,
  [TabRoutesEnum.twoFA]: 2,
  [TabRoutesEnum.logs]: 3,
  [TabRoutesEnum.trustedDevices]: 4,
} as const;
export const tabRoutes = [
  TabRoutesEnum.trustedDevices,
  TabRoutesEnum.logs,
  TabRoutesEnum.twoFA,
  TabRoutesEnum.password,
  TabRoutesEnum.username,
] as const;
